import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function applicationsReducer(
  state = initialState.application,
  action
) {
  if (action.type === types.LOAD_APPLICATION_SUCCESS) {
    return action.application;
  } else {
    return state;
  }
}
